module.exports = __webpack_public_path__ + "media/img/uploads/solutions-thumb-09-70980519542e55aeeeadfc3b8cf464c7.jpg";